export default __webpack_public_path__ + "static/media/26-1.04097d31.mp3";